import { render, staticRenderFns } from "./crm-header.vue?vue&type=template&id=0a5e3450"
import script from "./crm-header.vue?vue&type=script&lang=js"
export * from "./crm-header.vue?vue&type=script&lang=js"
import style0 from "./crm-header.vue?vue&type=style&index=0&id=0a5e3450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports